import { Button, ButtonRow, Heading, Text } from '@ksyos/design-system';
import { ServiceCode } from '../../../../common/enums/ServiceCode';
import { IntroContainer } from '../../elements/molecules/introContainer/IntroContainer';
import { Stack } from '../../elements/molecules/stack/Stack';

interface IQuestionnairesSentProps {
    serviceCode: ServiceCode;
}

export function QuestionnairesSent(props: IQuestionnairesSentProps) {
    return (
        <IntroContainer style={{ textAlign: 'center' }}>
            <Stack>
                <img
                    alt="Success"
                    src="/assets/images/derma-oth/success.svg"
                    style={{ maxWidth: '60%' }}
                />
            </Stack>
            <Stack>
                <Heading size="xlarge">Je antwoorden zijn verzonden</Heading>
            </Stack>

            {props.serviceCode !== ServiceCode.OSASQ && (
                <Stack>
                    <Text>De slaaparts bespreekt de resultaten met jou in een videoconsult.</Text>
                    <Text>Ksyos belt jou hierover op om een afspraak te maken.</Text>
                </Stack>
            )}

            <Stack>
                <ButtonRow justify="center">
                    <Button
                        color="secondary"
                        onClick={() => (window.location.href = '/')}
                        variant="solid"
                        width="full-below-small"
                    >
                        Terug naar Home
                    </Button>
                </ButtonRow>
            </Stack>
        </IntroContainer>
    );
}
